export const style = {
  color: "#f79009",
};

export const boxStyle = {
  display: "flex",
  flexDirection: "row",
  height: "100vh",
  alignItems: "center",
  justifyContent: "center",
};

export const paperStyle = {
  height: "700",
  overflow: "scroll",
  width: "100%",
};

export const textStyle = {
  display: {
    xs: "none",
    sm: "block",
  },
};
